/**
 * Layout shell for plan-scoped pages: /planning/plans/:cycleId/*
 *
 * Renders the child route via <Outlet>. The cycleId is available to all
 * child pages via useParams(). The sidebar switches to plan-context nav
 * automatically when the URL matches this prefix.
 */

import { Outlet, useParams } from 'react-router-dom';
import { PlanStateBar } from '@/components/plan-of-record/PlanStateBar';
import { StructureVersionFinePrint } from '@/components/hierarchy/StructureVersionFinePrint';
import { PlanPatternChanges } from '@/components/plan-of-record/PlanPatternDecision';
import { useItemLinkScope } from '@/lib/itemLinkScope';

export default function PlanDetailLayout() {
  const { cycleId } = useParams<{ cycleId: string }>();
  useItemLinkScope({ planCycleId: cycleId });
  return (
    <>
      {/* Which of the four states the plan is in (migration 919): being prepared,
          authorized and starting later, in force, or replaced. Here once, so every
          plan page carries it. */}
      {/* Breathing room between the bar and the page's own eyebrow (PLAN OF RECORD · …). */}
      {cycleId && (
        <div className="mb-6">
          <PlanStateBar planCycleId={cycleId} />
          <StructureVersionFinePrint table="plan_cycles" id={cycleId} mode="started" className="mt-1" />
          {/* A plan keeps the pattern versions it was authorized under until someone adopts a newer one (938). */}
          <PlanPatternChanges planCycleId={cycleId} />
        </div>
      )}
      <Outlet />
    </>
  );
}
